export default "https://cdn-static.gokick.com/assets/4894ba43e4289cab16e653fbabc6637092de6282/images/choco-chill.f91442e53028d067e0a40cd80e4e8aae.png";